import {
  ListGroup,
  ListGroupItem,
  Panel,
  PanelContent,
  PanelInteractiveLinks,
} from '@idexx-laboratories/spot-react';
import classNames from 'classnames';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from '../../hooks/use-store';
import './SideMenu.scss';

const SideMenu = observer(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const { globalStore, sideMenuStore: store } = useStore();
  const { currentPath, currentPathItem, pathsToShow } = store;

  useEffect(() => {
    runInAction(() => (store.currentPath = location.pathname));
  }, [location.pathname, store]);

  const doNavigate = (e: any, path: string, enabled: boolean): void => {
    if (enabled && path !== currentPath) {
      navigate(path);
      runInAction(() => (globalStore.leftNavPanelShown = false));
    }
    e.preventDefault();
  };

  return (
    <Panel
      headerTitle='Navigation'
      placement='left'
      closeOnEscape
      panelState={globalStore.leftNavPanelShown ? 'open' : 'closed'}
      onStateChange={state => runInAction(() => (globalStore.leftNavPanelShown = state === 'open'))}
    >
      <>
        <PanelContent>
          <PanelInteractiveLinks>
            <div className='side-menu'>
              {pathsToShow.map(path => {
                const menuItemEnabled = !path.enabled || path.enabled(globalStore);
                const className = classNames({
                  'menu-nav-link': !path.isSection,
                  subheader: path.isSection,
                  'not-allowed': !menuItemEnabled,
                });
                const { route } = path;
                if (route) {
                  return (
                    <div key={route} className={className}>
                      <ListGroupItem
                        href='#'
                        label={path.name}
                        role='side-menu-item'
                        aria-label={path.name}
                        data-testid={path.name}
                        active={path.route === currentPathItem.route}
                        onClick={e => doNavigate(e, route, menuItemEnabled)}
                      />
                    </div>
                  );
                }
                return (
                  <ListGroup
                    key={path.name}
                    className={className}
                    heading={path.item || path.name}
                  />
                );
              })}
            </div>
          </PanelInteractiveLinks>
        </PanelContent>
      </>
    </Panel>
  );
});

export default SideMenu;
